export const setToken = (token) => localStorage.setItem('token', token);
export const getToken = () => localStorage.getItem('token');
export const clearToken = () => localStorage.removeItem('token');
export const setEmail = (email) => localStorage.setItem('email', email);
export const clearEmail = () => localStorage.removeItem('email');
export const getEmail = () => localStorage.getItem('email');
